import { render, staticRenderFns } from "./BaseFile.vue?vue&type=template&id=5161897d&scoped=true"
import script from "./BaseFile.vue?vue&type=script&lang=js"
export * from "./BaseFile.vue?vue&type=script&lang=js"
import style0 from "./BaseFile.vue?vue&type=style&index=0&id=5161897d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161897d",
  null
  
)

export default component.exports